import { Component, Input } from '@angular/core';
import { FormGroup, FormControl } from '@angular/forms';
import { ValidationService } from '../../../services/validation';

@Component({
  selector: 'error-messages',
  template: `<small class='error' *ngIf='errorMessage !== null'>{{errorMessage}}</small>`
})

export class ErrorMessagesComponent {
  @Input() public control: FormControl;
  @Input() public submitted: boolean;

  get errorMessage() {
    for (let propertyName in this.control.errors) {
      if ((this.control.errors.hasOwnProperty(propertyName) && this.control.touched)
            || (this.control.pristine && this.submitted)) {
        return ValidationService.getValidatorErrorMessage(propertyName, this.control.errors[propertyName]);
      }
    }

    return null;
  }
}



// WEBPACK FOOTER //
// ./src/components/+utils/error_messages/error_messages.ts